module.exports = __webpack_public_path__ + "imgs/partners-hero2.2260c0103cce8fa060b215c794dafbc1.svg";